import { render, staticRenderFns } from "./PurchasingPurchaseOrdersPrint.vue?vue&type=template&id=2332d474&"
import script from "./PurchasingPurchaseOrdersPrint.vue?vue&type=script&lang=js&"
export * from "./PurchasingPurchaseOrdersPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports